import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col mt-42" }
const _hoisted_2 = { class: "order-1" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "h-20 w-40 border border-gray-bg flex flex-col justify-center items-center"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
  })
], -1)
const _hoisted_6 = { class: "text-sm w-24 overflow-x-hidden whitespace-nowrap text-center" }
const _hoisted_7 = { class: "order-3 text-center flex flex-col items-center lg:ml-8 lg:order-2 lg:text-left lg:items-start" }
const _hoisted_8 = { class: "font-basier text-dark-gray text-sm truncate w-64 md:w-80" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Plik: ")
const _hoisted_10 = { class: "font-semibold" }
const _hoisted_11 = { class: "w-36" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  id: "status",
  class: "font-basier font-semibold text-dark-gray text-sm"
}, " Typ dokumentu ", -1)
const _hoisted_13 = { class: "order-2 lg:ml-auto lg:mr-4 lg:order-3" }

import { ref, watchEffect } from 'vue'
import { UiButton, UiSelect } from '@/components/common/ui'
import { useDocumentTypes } from '@/composables/useDocumentTypes'
import { AdviceDeliveryReactionNewDocument } from '@/composables/useAdviceDeliveryReactions'
import { IMAGE_TYPES } from '@/types/consts'

type Props = {
    modelValue: AdviceDeliveryReactionNewDocument['images']
}
type Emit = {
    (e: 'update:modelValue', modelValue: AdviceDeliveryReactionNewDocument['images']): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: null, required: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update:modelValue', modelValue: AdviceDeliveryReactionNewDocument['images']): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    modelValue: AdviceDeliveryReactionNewDocument['images']
}




const { fetchDocumentTypes, documentTypes } = useDocumentTypes()
fetchDocumentTypes()

const shallowImages = ref<AdviceDeliveryReactionNewDocument['images']>([...props.modelValue])

const handleRemoveAttachment = (idx: number) => {
    shallowImages.value.splice(idx, 1)
}

watchEffect(() => emit('update:modelValue', shallowImages.value))

return (_ctx: any,_cache: any) => {
  const _component_IconCross = _resolveComponent("IconCross")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.modelValue, (image, imageIdx) => {
      return (_openBlock(), _createElementBlock("li", {
        key: `image-${imageIdx}`,
        class: _normalizeClass(["flex items-center justify-center flex-col border rounded-md mb-4 py-2 bg-opacity-5 border-opacity-30 animate-fade-in-up transition-opacity duration-200 hover:border-opacity-80 lg:flex-row", {
                'border-red bg-red': !image.documentTypeId,
                'border-green bg-green': image.documentTypeId,
            }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(IMAGE_TYPES).includes((image.type as string)))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: (image.base64 as string),
                class: "object-scale-down h-20 w-40 lg:ml-1"
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, _toDisplayString((image.type as string).split('/')[1]), 1)
              ]))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", _hoisted_10, _toDisplayString(image.fileName), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_unref(UiSelect), {
              modelValue: shallowImages.value[imageIdx].documentTypeId,
              "onUpdate:modelValue": ($event: any) => ((shallowImages.value[imageIdx].documentTypeId) = $event),
              options: _unref(documentTypes),
              "aria-labelledby": "status",
              style: {"padding":"0.25rem !important","margin-bottom":"0 !important"}
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_unref(UiButton), {
            "no-button-style": "",
            class: "delete-attachment rounded-full p-4",
            "tooltip-message": "Usuń plik",
            "confirmation-required": "",
            "confirmation-message": 'Czy na pewno usunąć załącznik?',
            onClick: ($event: any) => (handleRemoveAttachment(imageIdx))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconCross)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ], 2))
    }), 128))
  ]))
}
}

})